import AthleteUserViews from '../../views/entry/athleteUser/AthleteUserViews';

import NavLinks from '../../views/meet/NavLinks';

const INITIAL_STATE = [
  {
    name: AthleteUserViews.OME_MEET_CONTACTS,
    displayName: 'Contacts',
    path: NavLinks.ATHLETE_CONTACTS,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: AthleteUserViews.OME_MEET_ROSTER_ENTRIES_DETAIL,
    displayName: 'Entries',
    path: NavLinks.ATHLETE_ENTRIES,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: AthleteUserViews.OME_MEET_CREDENTIALS,
    displayName: 'Credentials',
    path: NavLinks.ATHLETE_CREDENTIALS,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: AthleteUserViews.OME_MEET_SUBMIT,
    displayName: 'Submit',
    path: NavLinks.ATHLETE_PURCHASES,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  }];

const GetInitialStateMeetRoute = (viewName) => {
  const state = INITIAL_STATE.find(x => x.name === viewName);
  return JSON.parse(JSON.stringify(state || {}));
};

export default GetInitialStateMeetRoute;